/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Whether the event kind requires recording
 */
export type EventKindRequiresRecording = boolean | null;
